import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_admin/resources/unsubscribe-lambda')({
  component: UnsubscribeLambdaLayout,
});

function UnsubscribeLambdaLayout() {
  return <Outlet />;
}
